import React from "react";
import { useTranslation } from "react-i18next";
import "./territory.css";
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";

const Territory = () => {
  const { t } = useTranslation();

  return (
    <BreathingBackground>
    <SectionWrapper>
    <article className="territory-page">
      {/* HERO */}
      <header className="territory-hero">
        <h1>{t("territory.title", "Territory · Santa María Tlahuitoltepec")}</h1>
        <p>
          {t(
            "territory.subtitle",
            "Mountain, community, and sound"
          )}
        </p>
      </header>

      {/* MONTAÑA */}
      <section className="territory-section">
        <h2>{t("territory.mountainTitle", "The mountain")}</h2>
        <p>
          {t(
            "territory.mountainText",
            "Santa María Tlahuitoltepec is located in the Mixe highlands of Oaxaca. The mountainous landscape shapes daily life, movement, and the way sound travels through space."
          )}
        </p>
        <p>
          {t(
            "territory.mountainText2",
            "Wind, altitude, and distance influence musical dynamics, rhythms, and the collective listening experience."
          )}
        </p>
      </section>

      {/* COMUNIDAD */}
      <section className="territory-section highlight">
        <h2>{t("territory.communityTitle", "Community")}</h2>
        <p>
          {t(
            "territory.communityText",
            "Community life in Tlahuitoltepec is organized around collective work, assemblies, and shared responsibilities. Music is part of this social structure, not a separate activity."
          )}
        </p>
        <p>
          {t(
            "territory.communityText2",
            "Musicians grow within the community, learning through participation rather than formal separation between performers and audience."
          )}
        </p>
      </section>

      {/* SONIDO */}
      <section className="territory-section">
        <h2>{t("territory.soundTitle", "Territory and sound")}</h2>
        <p>
          {t(
            "territory.soundText",
            "The sound of Mixe wind music reflects the territory where it is created. Open spaces, communal gatherings, and outdoor celebrations shape volume, tempo, and musical interaction."
          )}
        </p>
      </section>

      {/* IDENTIDAD */}
      <section className="territory-section highlight">
        <h2>{t("territory.identityTitle", "Identity and continuity")}</h2>
        <p>
          {t(
            "territory.identityText",
            "Kujipy carries this territorial identity into every performance, presenting music not as an isolated product, but as an expression rooted in land and community."
          )}
        </p>
      </section>
    </article>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default Territory;